module.exports = __webpack_public_path__ + "static/media/Barcode.64ff9115.svg";